import React from "react";

import { ITextBoxField } from "../models/formFields";
import { FormInputFieldWrapper } from "./FormInputFieldWrapper";
import { useFormField } from "./hooks/useFormField";

export const FormTextbox = <T extends string>(
    props: ITextBoxField<T>,
): React.ReactNode => {
    const { type = "textbox", rows, cols, minLength, maxLength } = props;

    const field = useFormField<T, HTMLTextAreaElement>({
        ...props,
        type: type,
    });

    const textareaProps = {
        ...field.inputProps,
        rows,
        cols,
        minLength,
        maxLength,
    };

    return (
        <FormInputFieldWrapper
            {...props}
            type={type}
            focused={field.focused}
            isRequired={field.isRequired}
            onLabelClick={field.onLabelClick}
        >
            <textarea ref={field.inputRef} {...textareaProps} />
        </FormInputFieldWrapper>
    );
};
